import i18n from "~/i18n/i18n";

export type EntityGrammar = "fOne" | "fOther" | "mOne" | "mOther";

export type EntityTerm = {
	grammar: EntityGrammar;
	text: string;
};

const SOURCE_LANGUAGE = "en";
const FALLBACK_GRAMMAR: EntityGrammar = "mOne";

const GRAMMAR_BY_ENTITY_SLUG: Record<string, EntityGrammar> = {
	acceptance: "fOne",
	acknowledgedQuantity: "fOne",
	activeImports: "fOther",
	activeSessionDetails: "mOther",
	addition: "fOne",
	additionalCosts: "mOther",
	address: "fOne",
	adjustment: "mOne",
	allStagedGrowpointDocuments: "mOther",
	allocation: "fOne",
	allocationSettings: "fOne",
	allocationTemplate: "fOne",
	allocations: "fOther",
	assignee: "fOne",
	availabilityRule: "fOne",
	blockingRule: "fOne",
	branding: "fOne",
	businessTimeZone: "fOne",
	calculationSteps: "mOther",
	capacityWindow: "fOne",
	carrier: "mOne",
	cashCollections: "mOther",
	catalog: "mOne",
	catalogs: "mOther",
	categories: "fOther",
	category: "fOne",
	categoryGlAccount: "fOne",
	characteristic: "fOne",
	characteristics: "fOther",
	clearingItemLaborCost: "fOne",
	code: "mOne",
	commissionConfiguration: "fOne",
	commissions: "fOther",
	companyProfile: "mOne",
	configCategories: "fOther",
	configCategory: "fOne",
	consolidationPreview: "fOne",
	consolidationRules: "fOther",
	contact: "mOne",
	contacts: "mOther",
	container: "mOne",
	containerConfigOverride: "fOne",
	containerConfigurations: "fOther",
	containers: "mOther",
	costData: "mOther",
	costReport: "mOne",
	count: "mOne",
	countHistory: "mOne",
	countSession: "fOne",
	countSessions: "fOther",
	counts: "mOther",
	credits: "mOther",
	crewView: "fOne",
	currentAvailability: "fOne",
	customer: "mOne",
	customerFreightConfig: "fOne",
	customerGroup: "mOne",
	customerHealth: "mOne",
	customerItem: "mOne",
	customerItems: "mOther",
	customerNotes: "fOther",
	customerNotification: "fOne",
	customerOverride: "fOne",
	customerType: "mOne",
	customerTypeGlAccount: "fOne",
	customers: "mOther",
	cycleCountAssignment: "fOne",
	dashboardMetrics: "fOther",
	data: "mOther",
	defaultCarrier: "mOne",
	defaultFreightCharge: "mOne",
	defaultPriceGroup: "mOne",
	defaultRoute: "fOne",
	defaultSender: "mOne",
	defaultTerms: "mOther",
	defaultVendor: "mOne",
	deliverySchedules: "mOther",
	detail: "mOne",
	device: "mOne",
	devices: "mOther",
	documentRenderMode: "mOne",
	domain: "mOne",
	driver: "mOne",
	effectiveDate: "fOne",
	emailSettings: "fOne",
	emailSend: "mOne",
	eventSchedule: "fOne",
	eventScheduleEdit: "fOne",
	eventType: "mOne",
	excludedItems: "mOther",
	flatRate: "fOne",
	folder: "fOne",
	forecast: "mOne",
	forecastAssumptions: "mOther",
	freight: "mOne",
	fusionauthUser: "mOne",
	glAccount: "fOne",
	gradeLabels: "fOther",
	growpointErrors: "mOther",
	hardGood: "mOne",
	hardGoods: "mOther",
	hardGoodsInventory: "mOne",
	hardgoodsConsumption: "mOne",
	ignoredWarning: "fOne",
	importJob: "mOne",
	importJobs: "mOther",
	integrationData: "mOther",
	inventory: "mOne",
	inventoryCorrection: "fOne",
	inventoryItem: "mOne",
	inventoryItems: "mOther",
	invite: "fOne",
	invoiceDraft: "mOne",
	item: "mOne",
	itemLaborCost: "mOne",
	itemNotes: "fOther",
	itemPrice: "mOne",
	itemPricing: "mOther",
	itemPrograms: "mOther",
	items: "mOther",
	job: "mOne",
	kit: "mOne",
	kitLinePrice: "mOne",
	kits: "mOther",
	laborRate: "fOne",
	laborSource: "fOne",
	laborType: "mOne",
	laborTypes: "mOther",
	layout: "mOne",
	learningProgress: "mOne",
	line: "fOne",
	lineItem: "fOne",
	lineItemNote: "fOne",
	lineItems: "fOther",
	linkedOrders: "mOther",
	load: "fOne",
	loadLine: "fOne",
	loadPaperworkPolicy: "fOne",
	loadPaperworkReport: "mOne",
	location: "fOne",
	locationNotes: "fOther",
	locations: "fOther",
	lot: "mOne",
	lotAllocations: "fOther",
	lots: "mOther",
	manualCost: "mOne",
	masterLineItem: "fOne",
	masterLineItems: "fOther",
	masterOrder: "mOne",
	masterOrderStatus: "mOne",
	materialEvent: "mOne",
	materialEvents: "mOther",
	materialItem: "mOne",
	materialItems: "mOther",
	metrics: "fOther",
	mfaRequirement: "mOne",
	minimumFreightCharge: "mOne",
	move: "mOne",
	name: "mOne",
	noTax: "fOne",
	note: "fOne",
	order: "mOne",
	orderAcknowledgementReport: "mOne",
	orderEntryUnit: "mOne",
	orderInvoiceReport: "mOne",
	orderKind: "mOne",
	orderNote: "fOne",
	orderProFormaReport: "mOne",
	orderReportPdf: "mOne",
	orderStatus: "mOne",
	orderVolumeDiscount: "mOne",
	orders: "mOther",
	otaRelease: "fOne",
	otaRollout: "mOne",
	overheadRate: "fOne",
	overridePrice: "mOne",
	pendingInvites: "fOther",
	photo: "fOne",
	pickupWindow: "fOne",
	plannedHours: "fOther",
	plantsPerPot: "fOther",
	portalCheckoutMethod: "mOne",
	portalHelpContact: "mOne",
	portalSettings: "fOne",
	postJobs: "mOther",
	postedAdjustments: "mOther",
	priceGroup: "mOne",
	priceLabel: "fOne",
	priceLevel: "mOne",
	pricePer: "mOne",
	pricing: "mOther",
	pricingCalcDecimals: "mOther",
	produceAllocate: "fOne",
	producedQtyLocation: "fOne",
	productionAdjustment: "mOne",
	productionItem: "mOne",
	productionItems: "mOther",
	productionJobs: "mOther",
	productionLine: "fOne",
	productionLines: "fOther",
	productionLot: "mOne",
	productionMappings: "fOther",
	productionPlan: "mOne",
	productionRecipe: "fOne",
	profilePicture: "fOne",
	program: "mOne",
	programs: "mOther",
	promotionRule: "fOne",
	purchaseOrder: "fOne",
	purchaseOrders: "fOther",
	qualificationConditions: "fOther",
	quantities: "fOther",
	quantity: "fOne",
	quickOrder: "mOne",
	rate: "fOne",
	reapplyRecipes: "fOne",
	receipt: "mOne",
	recentOrders: "mOther",
	recipe: "fOne",
	recipeBom: "fOne",
	recipeCostData: "mOther",
	recipeHistory: "mOne",
	recipeMaterials: "mOther",
	recipeSpacing: "mOne",
	recipeTasks: "fOther",
	recipeVariations: "fOther",
	recipes: "fOther",
	recipientRouting: "mOne",
	regrade: "fOne",
	removal: "fOne",
	reorder: "mOne",
	replenishmentRule: "fOne",
	replenishmentRules: "fOther",
	replenishmentSettings: "mOther",
	report: "mOne",
	reportPdf: "mOne",
	requiredQuantities: "fOther",
	rosterAccess: "mOne",
	route: "fOne",
	routeAccess: "mOne",
	row: "fOne",
	rowExplanation: "fOne",
	ruleDetails: "mOther",
	rules: "fOther",
	salesPerson: "mOne",
	schedule: "mOne",
	scheduleEmailSettings: "fOne",
	scheduledOrder: "mOne",
	scheduledTransfer: "fOne",
	scrap: "mOne",
	sender: "mOne",
	session: "fOne",
	sessionRowsForFilter: "fOther",
	sessions: "fOther",
	setting: "mOne",
	settingItemLaborCost: "fOne",
	settings: "mOther",
	shipDay: "mOne",
	shipFrom: "mOne",
	shipInventoryCheck: "fOne",
	shipmentWeightTracking: "mOne",
	shippedQuantity: "fOne",
	shrinkEvent: "mOne",
	siteAssignment: "fOne",
	siteLocation: "fOne",
	siteLocations: "fOther",
	sites: "mOther",
	sizeUom: "fOne",
	sizeUoms: "fOther",
	skip: "fOne",
	skippedGrades: "mOther",
	smtpConnection: "fOne",
	spaceCategories: "fOther",
	spaceCategory: "fOne",
	spaceEvent: "mOne",
	spaceEvents: "mOther",
	spacePlanning: "fOne",
	spaceType: "mOne",
	spaceTypes: "mOther",
	spacingOverrides: "fOther",
	spreadsheet: "fOne",
	storeClass: "fOne",
	stores: "fOther",
	tag: "fOne",
	tags: "fOther",
	task: "fOne",
	taskAssignment: "fOne",
	taskEvent: "mOne",
	taskEventTypes: "mOther",
	taskEvents: "mOther",
	tasks: "fOther",
	tenant: "mOne",
	tenantAccess: "mOne",
	tenantConfiguration: "fOne",
	tenantData: "mOther",
	term: "mOne",
	terms: "mOther",
	textStatus: "mOne",
	throughput: "mOne",
	timer: "mOne",
	transitKind: "mOne",
	trigger: "mOne",
	triggers: "mOther",
	unallocatedAvailability: "fOne",
	upcomingJobs: "mOther",
	upgrade: "fOne",
	upgrades: "fOther",
	user: "mOne",
	userInvite: "fOne",
	users: "mOther",
	value: "mOne",
	variation: "fOne",
	vehicle: "mOne",
	vehicleType: "mOne",
	vendor: "mOne",
	vendorCost: "mOne",
	vendorPrice: "mOne",
	vendorData: "mOther",
	vendorMaterialCosts: "mOther",
	vendorPurchaseOrders: "fOther",
	vendors: "mOther",
	weatherStation: "fOne",
	weeks: "fOther",
	whoCanCreateAProductionPlanFromAnOrder: "mOne",
	yearPlan: "mOne",
	yield: "mOne"
};

const toTermSlug = (term: string): string =>
	term
		.replace(/[^A-Za-z0-9]+/g, " ")
		.trim()
		.split(" ")
		.filter(Boolean)
		.map((word, index) =>
			index === 0 ? word.toLowerCase() : `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`
		)
		.join("");

const rendersSourceLanguage = (): boolean => (i18n.language ?? SOURCE_LANGUAGE).startsWith(SOURCE_LANGUAGE);

const translateTerm = (group: string, term: string): string =>
	rendersSourceLanguage() ? term : i18n.t(`snack.${group}.${toTermSlug(term)}`, { defaultValue: term, ns: "common" });

const entityTerm = (entity: string): EntityTerm => ({
	grammar: GRAMMAR_BY_ENTITY_SLUG[toTermSlug(entity)] ?? FALLBACK_GRAMMAR,
	text: translateTerm("entity", entity)
});

const countedEntityText = (entity: string, count: number): string =>
	count === 1 || rendersSourceLanguage()
		? translateTerm("entity", entity)
		: i18n.t(`snack.entityPlural.${toTermSlug(entity)}`, {
				defaultValue: translateTerm("entity", entity),
				ns: "common"
			});

const actionText = (action: string): string => translateTerm("action", action);

const snackTerms = {
	actionText,
	countedEntityText,
	entityTerm
} as const;

export default snackTerms;
